// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".SimpleSearchBar__container--4E-Wv {\n  position: relative;\n  display: flex;\n  width: 100%;\n}\n\n.SimpleSearchBar__search-icon--2WFgr {\n  fill: currentColor;\n  width: 16px;\n  height: 16px;\n}\n", "",{"version":3,"sources":["SimpleSearchBar.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd","file":"SimpleSearchBar.css","sourcesContent":[".container {\n  position: relative;\n  display: flex;\n  width: 100%;\n}\n\n.search-icon {\n  fill: currentColor;\n  width: 16px;\n  height: 16px;\n}\n"]}]);
// Exports
exports.locals = {
	"container": "SimpleSearchBar__container--4E-Wv",
	"search-icon": "SimpleSearchBar__search-icon--2WFgr",
	"searchIcon": "SimpleSearchBar__search-icon--2WFgr"
};
module.exports = exports;
